// Filename: gnnodexdatals.js
// Timestamp: 2018.01.15-23:23:17 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>


import {
  gnarrReduceTuple as arrReduceTuple
} from './gnarr.js'

import {
  gnnodeChildKeysGet as nodeChildKeysGet,
  gnnodeAssign as nodeAssign
} from './gnnode.js'

import {
  gngraphNodeSet as graphNodeSet,
  gngraphNodeSiblingPrevGetKey as graphNodeSiblingPrevGetKey,
  gngraphNodeSiblingNextGetKey as graphNodeSiblingNextGetKey,
  gngraphNodeChildSet as graphNodeChildSet
} from './gngraph.js'

import gnnodex from './gnnodex.js'
import gnnodexdata from './gnnodexdata.js'

import {
  gnaccSubj as accSubj,
  gnaccInit as accInit,
  gnaccFKey as accFKey
} from './gnacc.js'

import {
  gnnodeosCreateInit as nodeosCreateInit,
  gnnodeosChildRm as nodeosChildRm,

  gnnodeosChildSpecWhenFirst,
  gnnodeosChildSpecFromRef,
  gnnodeosNSHydrateSuchFromChildsRefresh,
  gnnodeosNSHydrate
} from './gnnodeos.js'

import {
  gnpublish_persistgraph
} from './gnpublish.js'

import {
  gnspec_childprefromspec
} from './gnspec.js'

import {
  gnenumSPECNODETYPES as SPECNODETYPES,
  gnenumXONCHILDADD as XONCHILDADD,
  gnenumXONCHILDADDED as XONCHILDADDED,
  gnenumXONCHILDREMOVE as XONCHILDREMOVE,
  gnenumXONCHILDREMOVED as XONCHILDREMOVED,

  gnenumKEY as KEY,
  gnenumKEYACTIVE as KEYACTIVE,
  gnenumISDATA as ISDATA,
  gnenumCHILD as CHILD,
  gnenumNAME as NAME
} from './gnenum.js'

const xinit = nd => (
  nd = nodeAssign(nd, {
    [ISDATA]: true
  }),

  nd = accSubj.specpush(nd, {
    [KEYACTIVE]: '',
    childlength: '',
    childadded: '',
    childaddedfirst: '',
    childremoved: '',
    childremovedlast: ''
  }),
  nd)

const xonchildadd = (ss, cfg, gr, ndp, ndc) => {
  const childkey = ndc.get(KEY)
  const childlength = nodeChildKeysGet(ndp).length

  ndp = accSubj.assign(ndp, {
    childadded: childkey,
    childlength
  })

  if (childlength === 1) {
    ndp = accSubj.propset(
      ndp, KEYACTIVE, childkey)
  }

  const graphsetres = graphNodeSet(gr, ndp)
  gr = graphsetres[0]
  ndp = graphsetres[1]

  gnpublish_persistgraph(cfg, gr)

  return [gr, ndp, ndc]
}

const populatechild = async (ss, cfg, gr, ndp, fulldata) => {
  let childarr = ndp.get(CHILD, []),
      childlength = nodeChildKeysGet(ndp).length,
      childnode,
      childspec,
      mnode,
      res

  childspec = await gnnodeosChildSpecWhenFirst(
    ss, cfg, gr, ndp, fulldata, childarr)

  // if (!childspec) {
  //   const spectypes = ndp.get(SPECNODETYPES) || {}
  //   const spectypekeys = Object.keys(spectypes)
  //   childspec = { spec: spectypekeys[0] }
  // }
  if (!childspec) {
    throw new Error('un-supported, no spectype')
  }

  const childspecfull = await gnnodeosChildSpecFromRef(
    ss, cfg, gr, ndp, childspec, ndp.get(SPECNODETYPES))

  childspec = await gnspec_childprefromspec(
    ss, cfg, gr, ndp, fulldata, childlength, childspec, childspecfull)

  childnode = nodeosCreateInit(cfg, gr, childspec, ndp)
  childnode = accFKey.assign(childnode, {
    [ndp.get(NAME)]: ndp.get(KEY)
  })

  res = graphNodeChildSet(
    gr, ndp, childnode, childnode.get(NAME, null))

  gr = res[0]
  ndp = res[1]
  childnode = res[2]

  res = await gnnodeosNSHydrate(ss, cfg, gr, childnode, accInit)
  gr = res[0]
  mnode = res[1]

  res = await gnnodeosNSHydrate(ss, cfg, gr, mnode, accSubj)
  gr = res[0]
  mnode = res[1]

  return [gr, ndp, mnode]
}

// pass parent fkey down to list childs
//
// here definitions on the parent node are used to describe relationships
// with child subjects, using parent's 'fkeyname'
const addchilddata = async (ss, cfg, gr, ndp, ndx, fulldata) => {
  if (!fulldata)
    throw new Error('fulldata is required')

  let res, ndc

  res = await populatechild(ss, cfg, gr, ndp, fulldata)
  gr = res[0]
  ndp = res[1]
  ndc = res[2]

  res = ndx[XONCHILDADD](ss, cfg, gr, ndp, ndc)
  gr = res[0]
  ndp = res[1]
  ndc = res[2]

  // rebuild accumulator values...
  gr = await gnnodeosNSHydrateSuchFromChildsRefresh(ss, cfg, gr, ndp)
  // gr = res[0]
  ndp = gr.get(ndp.get(KEY))
  ndc = gr.get(ndc.get(KEY))

  gr = await gnnodex.publishevPOSTns(ss, cfg, gr, ndp, XONCHILDADDED, {
    node: ndc
  })

  return [gr, ndp, ndc]
}

const setnextactivekey = (ss, cfg, gr, nd, activekey) => {
  const nextkey = graphNodeSiblingNextGetKey(gr, gr.get(activekey))
    || graphNodeSiblingPrevGetKey(gr, gr.get(activekey))

  // const nextkey = gnnode_siblingnextorprevkeyget(
  //   ss, cfg, gr, gr.get(activekey))

  nd = accSubj.propset(nd, KEYACTIVE, nextkey)

  return nd
}

// remove nodefrom list...
const xonchildremove = (ss, cfg, gr, nd, ckey) => {
  const activekey = accSubj.propget(nd, KEYACTIVE)
  const childlength = nodeChildKeysGet(nd).length

  nd = accSubj.assign(nd, {
    childremoved: ckey,
    childlength
  })

  if (activekey === ckey) {
    nd = setnextactivekey(ss, cfg, gr, nd, activekey)
  }

  const graphsetres = graphNodeSet(gr, nd)
  gr = graphsetres[0]
  nd = graphsetres[1]

  gnpublish_persistgraph(cfg, gr)

  return [gr, nd]
}

const rmchild = async (ss, cfg, gr, nd, ndx, ckey) => {
  const cnode = gr.get(ckey)

  let res = nodeosChildRm(ss, cfg, gr, nd, ckey)
  gr = res[0]
  nd = res[1]

  const rmchildres = ndx[XONCHILDREMOVE](ss, cfg, gr, nd, ckey)
  gr = rmchildres[0]
  nd = rmchildres[1]

  gr = await gnnodeosNSHydrateSuchFromChildsRefresh(ss, cfg, gr, nd)
  nd = gr.get(nd.get(KEY))
  // gr = res[0]
  // const ndp = res[1]

  gr = await gnnodex.publishevPOSTns(ss, cfg, gr, nd, XONCHILDREMOVED, {
    node: cnode
  })

  return [gr, nd]
}

// returns (err, graph, pnode)
const rmchildarr = async (ss, cfg, gr, nd, ndx, ckeyarr) => (
  arrReduceTuple(ckeyarr, async (gr, ndp, _, ckey) => (
    ndx.rmchild(ss, cfg, gr, ndp, ndx, ckey)
  ), [gr, nd, {}]).then(async res => (
    gnnodeosNSHydrateSuchFromChildsRefresh(ss, cfg, res[0], res[1])
  )))

// rebuilds and replaces existing cnode comprehensively
// obtains and uses spec data anew and does not use
// existing node spec data
//
// if the 'type' of node changes and facilitates using a new spec
// use ths function
//
// o.setchilddata = (ss, cfg, gr, ndp, ndc, data, fn) => {
//   let childs = ndp.get(CHILD, [])
//
//   data = Object.assign(
//     accSubj.get(ndc), data)
//
//   gnnode_childspecwhenparentfirst(
//     ss, cfg, gr, ndp, data, childs, (e, cspec) => {
//       if (e) return fn(e)
//
//       const spec = gnnodeosChildSpecFromRef(
//         ss, cfg, gr, ndp, cspec, ndp.get('spectypes'))
//
//       ndc = gnacc_init.rmspec(ndc)
//       ndc = accSubj.rmspec(ndc)
//       ndc = sphnode_assign(ndc, spec)
//       ndc = gnacc_baseelem.set(ndc, data)
//
//       gnnode_prophydrateinit(ss, cfg, gr, ndc, (e, gr, ndc) => {
//         if (e) return fn(e)
//
//         gnnode_prophydratesubj(ss, cfg, gr, ndc, (e, gr, ndc) => {
//           if (e) return fn(e)
//
//           gr = gr.set(ndc.get(KEY), ndc)
//
//           fn(null, gr, ndp, ndc)
//         })
//       })
//     })
// }

const xhydratedsubj = async (ss, cfg, gr, nd) => {
  const graphsetres = graphNodeSet(gr, accSubj.assign(nd, {
    childlength: nodeChildKeysGet(nd).length
  }))

  gr = graphsetres[0]
  nd = graphsetres[1]
  return [gr, nd]
}

export default Object.assign({}, gnnodexdata, {
  type: 'gnnodexdatals',
  xinit,
  xhydratedsubj,
  [XONCHILDREMOVE]: xonchildremove,
  [XONCHILDADD]: xonchildadd,
  populatechild,
  addchilddata,
  rmchild,
  rmchildarr,
  setnextactivekey
})
